import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CheckboxEmptyIcon = ({ size = 'small' }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            style={{ borderRadius: '2px' }}
            data-testid={'icon-checkboxEmpty'}
        >
            <title>Checkbox Empty</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-276.000000, -327.000000)" fill="#FFFFFF" stroke="#9DB2C4">
                    <rect x="276.5" y="327.5" width="19" height="19"></rect>
                </g>
            </g>
        </svg>
    );
};
